<template>
  <span class="badge rounded-pill align-self-center ms-2">{{ text }}</span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    text: {
      type: String,
      required: true
    },
  }
}
</script>
